import { PythonTopic } from '../../../../types/python-topic';
import { aleatoriedadExercises } from './exercises';

export const aleatoriedadTopic: PythonTopic = {
  id: 4,
  title: 'Aleatoriedad',
  description: 'Aprende a trabajar con números aleatorios usando el módulo random de Python: simulaciones, datos de prueba, muestreo y reproducibilidad.',
  theory: `# Aleatoriedad en Python

## ¿Qué aprenderás en esta sección?

Esta sección te introduce a:
1. **Módulo random**: Generar números aleatorios
2. **Simulaciones**: Dados, probabilidades, eventos
3. **Datos de prueba**: Generar datos realistas para testing
4. **Reproducibilidad**: Usar seed() para resultados consistentes

## Números Aleatorios

El módulo random te permite:
- Generar números aleatorios (enteros y decimales)
- Simular eventos aleatorios y probabilísticos
- Crear datos de prueba estructurados
- Muestrear y mezclar colecciones

## Estructura de esta sección

Cada ejercicio incluye teoría expandida, ejemplos prácticos y ejercicios para que puedas practicar a tu propio ritmo.`,
  difficulty: 'intermediate',
  exercises: aleatoriedadExercises
};

